import AddIcon from "@mui/icons-material/Add";
import type { TButtonMenuOption } from "components/shared/ButtonOptionsMenu";
import ButtonOptionsMenu from "components/shared/ButtonOptionsMenu";
import { useTranslation } from "react-i18next";

interface IAddRolesOptions {
    /**
     * All notification roles options
     */
    rolesOptions: TButtonMenuOption[];
    /**
     * Handle update role
     */
    handleUpdateRole: (chosenOptions: TButtonMenuOption[]) => void;
    /**
     * set Chosen options
     */
    setChosenOptions: React.Dispatch<React.SetStateAction<TButtonMenuOption[] | undefined>>;
    /**
     * Chosen options
     */
    chosenOptions: TButtonMenuOption[] | undefined;
    /**
     * Set is dirty
     */
    setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
}
/**
 * Render button with popover options to select roles to add for the scoped notification
 */
const AddRolesOptions = ({
    rolesOptions,
    handleUpdateRole,
    setChosenOptions,
    chosenOptions,
    setIsDirty,
}: IAddRolesOptions) => {
    const [t] = useTranslation();
    if (!chosenOptions) return;

    const handleChooseOption = (option: TButtonMenuOption) => {
        const isSelected = chosenOptions?.some((opt) => opt?.id === option.id);
        if (isSelected) {
            setChosenOptions(chosenOptions?.filter((opt) => opt.id !== option.id));
        } else {
            setChosenOptions([...chosenOptions, option]);
        }
        setIsDirty(true);
    };

    return (
        <ButtonOptionsMenu
            icon={<AddIcon style={{ height: "16px", width: "16px" }} />}
            handleChooseOption={handleChooseOption}
            disabledTooltip={t("Management.EssentialColumn")}
            options={rolesOptions}
            chosenOptions={chosenOptions}
            handleClosePopoverAction={() => handleUpdateRole(chosenOptions)}
            optBtnType="checkbox"
            size="tiny"
        />
    );
};

export default AddRolesOptions;
